module.exports = __webpack_public_path__ + "img/sold_love.094a0938.png";